import React from 'react';

import { ButtonBase, Typography } from 'components';
import { Add } from 'iconsax-react';

import { palette } from 'styles/theme';

type Props = {
  label: string;
  onClick: () => void;
  width?: string;
  minHeight?: string;
};

export const AddCardBox: React.FC<Props> = ({
  label,
  onClick,
  width = '100%',
  minHeight = '11rem',
}) => (
  <ButtonBase
    aria-label={label}
    onClick={onClick}
    sx={{
      width,
      // minHeight rather than height so the tile stretches to the row set by the
      // cards beside it, whose border makes them 2px taller than their own height.
      minHeight,
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      borderRadius: '12px',
      border: `1px dashed ${palette.grey400}`,
      backgroundColor: 'transparent',
      transition:
        'border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease',
      '&:hover': {
        borderColor: palette.primary900,
        backgroundColor: palette.primary0,
        transform: 'translateY(-1px)',
      },
      '&.Mui-focusVisible': {
        borderColor: palette.primary900,
        backgroundColor: palette.primary0,
        // Drawn inside the border box: both grids clip what paints outside it.
        outline: `2px solid ${palette.primary900}`,
        outlineOffset: '-2px',
      },
    }}
  >
    <Add variant="TwoTone" size="32" color={palette.primary900} />
    <Typography variant="body1" color="primary">
      {label}
    </Typography>
  </ButtonBase>
);
